<template>
  <a
    href="javascript:void(0)"
    class="link"
    @click.prevent="changeContent(thumb)"
  >
    <div class="thumb-box">
      <ul class="badge-list">
        <li class="left-top-area">
          <ul v-top-tag-list="tagList(thumb)" />
        </li>
      </ul>
      <div v-if="image" class="picture-area">
        <WebpImage
          :image-info="{
            imageUrl: image,
            width: 240,
            height: 360,
            alt: alt,
            onImageLoad,
          }"
        />
      </div>
      <div v-else class="no-thumb" :aria-hidden="!isImageLoaded">
        <span class="alt-text">{{ alt }}</span>
      </div>
    </div>
    <div class="detail-info-box">
      <strong class="subject">{{ title.title }}</strong>
      <div class="meta-list">
        <span
          v-for="(meta, index) in title.metaList"
          :key="index"
          class="meta"
          >{{ meta }}</span
        >
      </div>
      <p class="dsc" v-html="synopsis" />
    </div>
  </a>
</template>

<script>
  import _ from 'lodash'
  import { commonTagList, topTagList } from '@/common/resources/directives'
  import { CellEventMapper } from '@/common/utils/gnb.fp'
  import WebpImage from '@/components/image/WebpImage'

  export default {
    name: 'SeriesItem',
    components: { WebpImage },
    directives: {
      topTagList,
      commonTagList,
    },
    props: {
      thumb: {
        type: Object,
      },
    },
    data() {
      return {
        isImageLoaded: false,
      }
    },
    computed: {
      alt() {
        return _.get(this.thumb, 'alt', '')
      },
      image() {
        return _.get(this.thumb, 'thumbnail', '')
      },
      title() {
        const titleList = _.get(this.thumb, 'title_list', [])
        const [titleMain, titleSub] = titleList
        const title = _.get(titleMain, 'text', '')
        const metaList = _.get(titleSub, 'text', '')
          .replace(/ /gi, '')
          .split(/\$\w\$/gi)

        return { title, metaList }
      },
      synopsis() {
        return _.get(this.thumb, 'synopsis', [])
      },
    },
    methods: {
      changeContent(thumb) {
        const { event_list: eventList = [] } = thumb
        const { onNavigation } = CellEventMapper(eventList)
        const navigationUrl = onNavigation?.url || ''
        this.$router.push(navigationUrl).catch(() => {})
      },
      tagList(thumb) {
        return _.get(thumb, 'top_taglist', []).concat(
          _.get(thumb, 'bottom_taglist', []),
        )
      },
      onImageLoad() {
        this.isImageLoaded = true
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .link {
    display: flex;
    align-items: center;
  }
</style>
<style lang="scss" scoped>
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .detail-info-box {
    margin-left: 20px;
    .subject {
      @include Ellipsis();
      display: block;
      font-size: 16px;
      font-weight: normal;
      color: #fff;
      line-height: 24px;
    }
    .meta-list {
      margin-top: 4px;
      font-size: 14px;
      color: $neutral-80;
      line-height: 18px;
    }
    .meta-list .meta {
      display: inline-block;
      vertical-align: top;
    }
    .meta-list .meta::before {
      display: inline-block;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      margin: 8px 4px 0;
      background-color: $neutral-80;
      vertical-align: top;
      content: '';
    }
    .meta-list .meta:first-of-type::before {
      display: none;
    }
    .dsc {
      @include Ellipsis($multi: true, $line: 5);
      margin-top: 16px;
      font-size: 16px;
      color: $neutral-80;
      line-height: 24px;
    }
  }
</style>
